var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80008 9.61291C2.06597 8.91704 1.48672 8.07429 1.10008 7.13958C1.03405 6.98583 1 6.82024 1 6.65291C1 6.48558 1.03405 6.32 1.10008 6.16625C1.61354 4.91717 2.47418 3.84138 3.58008 3.06625C4.62975 2.33272 5.88657 1.95427 7.16675 1.98625C8.0878 1.96312 9.00135 2.15725 9.83341 2.55291M11.5401 3.69958C12.2703 4.3948 12.847 5.235 13.2334 6.16625C13.2994 6.32 13.3335 6.48558 13.3335 6.65291C13.3335 6.82024 13.2994 6.98583 13.2334 7.13958C12.7199 8.38866 11.8593 9.46445 10.7534 10.2396C9.70374 10.9731 8.44692 11.3516 7.16675 11.3196C6.24569 11.3427 5.33214 11.1486 4.50008 10.7529",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97341 7.43333C4.87992 7.18395 4.83248 6.91966 4.83341 6.65333C4.83341 6.03449 5.07925 5.441 5.51683 5.00342C5.95442 4.56583 6.54791 4.32 7.16675 4.32C7.43341 4.31867 7.69741 4.36667 7.94675 4.46M9.36008 5.87333C9.45342 6.12267 9.50142 6.38667 9.50008 6.65333C9.50008 7.27217 9.25425 7.86566 8.81666 8.30325C8.37908 8.74083 7.78559 8.98667 7.16675 8.98667C6.90042 8.9876 6.63613 8.94016 6.38675 8.84667M1.16675 11.6667L11.8334 1",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/CloseEye.1c1ffe9046cebc4d5f57575126198fe0.svg";
export { ForwardRef as ReactComponent };